// extracted by mini-css-extract-plugin
export var lg = "_4g-4";
export var md = "_4g-3";
export var sm = "_4g-2";
export var xs = "_4g-1";
export var xxs = "_4g-0";